import moment from 'moment';
import fetch from '@/utils/fetch';
// import cityData from '@/utils/city';
import { message } from 'antd';

const directTypeMap = {
  10: 0,
  20: 1,
  40: 2,
  3: 3,
  4: 4,
};
const model = {
  state: {
    list: [],
    listNew: [],
    loading: false,
    total: 0,
    totalNew: 0,
    pageSize: 10,
    detail: {},
    bannerType: null, // 默认首页banner
    isGoToDetailBack: false, // 是否是从详情页返回列表页
    pageBannerMap: {
      home: 0, // 首页
      shopHome: 1, // 外卖首页
      dishRecommend: 2, // 外卖菜品推荐
    },
  },
  reducers: {
    setState(state, partialState) {
      return { ...state, ...partialState };
    },
  },
  actions: ({ dispatch: { shopAdvertisement, basic }, getState }) => ({
    async updateAdvertisementRank(params) {
      const data = await fetch('/saasmerchant/web/advertisement/updateAdvertisementRank', {
        params,
      });
      if (data) {
        message.success('操作成功');
      }
      return data;
    },
    async updateShowAdvertisement(params) {
      const data = await fetch('/saasmerchant/web/advertisement/updateShowAdvertisement', {
        params,
      });
      if (data) {
        message.success('操作成功');
      }
      return data;
    },
    async delAdvertisement(params) {
      const data = await fetch('/saasmerchant/web/advertisement/delAdvertisement', { params });
      if (data) {
        message.success('操作成功');
      }
      return data;
    },
    async getAdvertisementDetail(params) {
      const data = await fetch('/saasmerchant/web/advertisement/getAdvertisementDetail', {
        params,
      });
      if (data) {
        shopAdvertisement.setState({
          detail: data,
        });
      }
      return data;
    },
    async newOrUpdateAdvertisement(params) {
      let targetList;
      const cityData = getState().basic?.cityData || [];
      switch (params.scope) {
        // 处理城市code
        case 1:
          targetList = JSON.parse(params.citys || '[]').map((item) => {
            return {
              targetText: item,
              targetValue: (cityData.find((city) => city.label === item) || {}).value,
            };
          });
          break;
        // 处理商圈
        case 2:
          targetList = params.cbd.map((item) => ({
            targetText: item.label,
            targetValue: item.key,
          }));
          break;
        default:
          break;
      }
      const url = params.advertisementId
        ? '/saasmerchant/web/advertisement/updateAdvertisement'
        : '/saasmerchant/web/advertisement/newAdvertisement';
      const data = await fetch(url, {
        type: 'POST',
        useJson: true,
        params: {
          companyListType: params.companyListType,
          companyList: params.companyList,
          advertisementId: params.advertisementId,
          name: params.name,
          type: getState().shopAdvertisement.bannerType,
          channel: 0,
          targetType: params.scope,
          rank: params.rank,
          availableTimeType: 0, // 生效时间模式，0按起始时间，1按星期几
          startTime: moment(params.startTime).format('YYYY-MM-DD HH:mm:ss'),
          endTime: moment(params.endTime).format('YYYY-MM-DD HH:mm:ss'),
          // dayRange
          redirectType: directTypeMap[params.redirectType],
          content: params.content,
          pictureUrl: params.picture,
          // skuBaseIds
          shopId: params.shop && params.shop.split('-')[0],
          subShopId: params.shop && params.shop.split('-')[1],
          // shopName: params.shop && params.shop.split('-')[2],
          targetList,
          appId: params.appId,
          redirectUrl: params.redirectUrl,
        },
      });
      if (data) {
        if (params.advertisementId) {
          message.success('修改成功');
        } else {
          message.success('创建成功');
        }
      }
      return data;
    },
    async getList(params = {}) {
      shopAdvertisement.setState({ loading: true });
      params.type = getState().shopAdvertisement.bannerType;
      params.pageSize = getState().shopAdvertisement.pageSize;
      const data = await fetch('/saasmerchant/web/fsad/search', {
        type: 'POST',
        params,
        useJson: true,
      });
      if (data) {
        shopAdvertisement.setState({ list: data.list, total: data.total });
      }
      shopAdvertisement.setState({ loading: false });
    },
    async getListNew(params = {}) {
      shopAdvertisement.setState({ loading: true });
      params.type = getState().shopAdvertisement.bannerType;
      const data = await fetch('/saasmerchant/web/advertisement/getAdvertisementList', {
        params: {
          channel: 0, // 渠道 0:小程序, 1:H5, 2全选
          companyListType: params.companyListType,
          type: params.type, // 0：首页banner 1：外卖首页banner 2：菜品推荐
          advertisementName: params.name,
          cityIdList: params.city,
          // companyIdList: [],
          businessIdList: params.cbd ? params.cbd.key : '',
          redirectType: params.jump, // 跳转类型 0不跳转 1静态页面 2店铺
          // timeStatus: '',
          status: params.status,
          targetType: params.scope, // 投放范围类型 0:全平台, 1:按城市, 2:按商圈, 3:按企业
          pageSize: 10,
          pageNum: params.page,
        },
      });
      if (data) {
        shopAdvertisement.setState({ listNew: data.list, totalNew: data.total });
      }
      shopAdvertisement.setState({ loading: false });
      return data;
    },
    async getChooseCompanyList(parent_company_name) {
      const { union_shop_id } = getState().basic;
      const data = await fetch('/company/manage/companygetlist', {
        type: 'POST',
        params: { parent_company_name, pageSize: 20, pageNum: 1, status: 2, union_shop_id },
      });
      return data;
    },
    async move(adId, step) {
      const result = await fetch('/saasmerchant/web/fsad/move', {
        type: 'POST',
        params: {
          adId,
          step,
        },
      });
      if (result) {
        message.success('移动成功');
        shopAdvertisement.getList();
      }
    },
    async setStatus(adId, status) {
      const result = await fetch('/saasmerchant/web/fsad/setStatus', {
        type: 'POST',
        params: {
          adId,
          status,
        },
      });
      if (result) {
        message.success('状态更新成功');
        shopAdvertisement.getList();
      }
    },
    async addAd(params, history) {
      const result = await fetch('/saasmerchant/web/fsad/add', {
        type: 'POST',
        params,
        useJson: true,
      });
      if (result) {
        message.success('创建成功');
        history.push('/user/advertisement');
      }
    },
    async getDetail(params) {
      const data = await fetch('/saasmerchant/web/fsad/detail', { params });
      if (data) {
        shopAdvertisement.setState({ detail: data });
      }
      return data;
    },
    clearDetail() {
      shopAdvertisement.setState({ detail: {} });
    },
    async updateAd(params, history) {
      const result = await fetch('/saasmerchant/web/fsad/update', {
        type: 'POST',
        params,
        useJson: true,
      });
      if (result) {
        message.success('修改成功');
        history.push('/user/advertisement');
      }
    },
    setBannerType(type) {
      shopAdvertisement.setState({ bannerType: type });
    },
    setGoToDetailPage(isToPageDetail) {
      shopAdvertisement.setState({ isGoToDetailBack: isToPageDetail });
    },
  }),
};

export default model;
